import React,{Component} from "react";
import {AppBackground, MediumFont, TextColor, ThinBorder} from '../../styles/BaseStyles';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import MoneyCard from "./MoneyCard";
import TimeCard from "./TimeCard";
import Button from '@material-ui/core/Button';
import { shadows } from '@material-ui/system';
import { Link as RouterLink } from 'react-router-dom'
import Link from '@material-ui/core/Link';
import Typography from "@material-ui/core/Typography";
//Farshid
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
//import Button from '@material-ui/core/Button';
import {bindActionCreators} from "redux";
import {loginAction, saveAComment, updateUserProfileAction} from "../../redux/modules/login";
import {connect} from "react-redux";
import Divider from "@material-ui/core/Divider";
import TextField from "@material-ui/core/TextField";
import {DEFAULT_VESPAAN_SERVER} from "../../utils/MainConstants";
import Image from 'material-ui-image'
import * as MainConstants from "../../utils/MainConstants";

//import {updateUserProfileAction, saveAComment} from "../../redux/modules/login";
//import {bindActionCreators} from "redux";
//import {connect} from "react-redux";
//import {DEFAULT_VESPAAN_SERVER} from "../../utils/MainConstants";
//End Farshid



const Styles = theme => ({
  root: Object.assign({}, AppBackground, MediumFont),
  gridPane: {width: '50%', display: 'inline-block'},
  paneTable: {width: '100%', height: '100%',  backgroundColor:'grey'},
  videoPane: {width: '50%', display: 'inline-block', verticalAlign: 'top'},
  penInfoPanel: {color: 'white', fontSize: 20},
  penInfoPanelSelected: Object.assign({color: 'white', fontSize: 20}, ThinBorder),
  videoPanel: {marginTop: 0},
  penName: {color: TextColor, fontSize: 20, marginLeft: 10, cursor: 'pointer', display: 'inline-block'},
  metricValue: {display: 'inline-block', width: 100, height: 100, cursor: 'pointer'},
  container: {
    display: 'grid',
    gridTemplateColumns: 'repeat(12, 1fr)',
    gridGap: `${theme.spacing.unit * 3}px`,
  },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  divider: {
    margin: `${theme.spacing.unit * 2}px 0`,
  },
  metricInfo: Object.assign({}, AppBackground, ThinBorder)
  
});

const styles = theme => ({
  container: {
    display: 'grid',
    gridTemplateColumns: 'repeat(12, 1fr)',
    gridGap: `${theme.spacing.unit * 3}px`,
  },
  paper: {
    padding: theme.spacing.unit,
    textAlign: 'center',
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap',
    marginBottom: theme.spacing.unit,
  },
  divider: {
    margin: `${theme.spacing.unit * 2}px 0`,
  },
  leftPane: {width: '25%', height: '100%', verticalAlign: 'top', backgroundColor:'red'},
  rightPane: {fontSize: 40, color: 'black', verticalAlign: 'top', backgroundcolor:'red'},
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
  },
  button: {
    margin: theme.spacing.unit,
  },
  extendedIcon: {
    marginRight: theme.spacing.unit,
  },
  margin: {
    margin: theme.spacing.unit * 2,
  },
  dividerColorPurpole: {
    //marginTop: theme.spacing.unit * 3,
    height: '20px',
    color:"#ffffff",
    //backgroundColor:"#760eb3",
  },
  
  multilineColor:{
    color:'black',
    backgroundColor:'#f5f7e8'
  }
});


class AboutPlateWiz extends Component {
  
  state = {
    age: '',
    name: 'hai',
    firstname: '',
    lastname:'',
    email:'',
    comment:'',
    userComment:{}
  };
  
  constructor(props) {
    super(props);
    
    this.handleFirstNameChange = this.handleFirstNameChange.bind(this);
    this.handleLastNameChange = this.handleLastNameChange.bind(this);
    this.handleEmailChange= this.handleEmailChange.bind(this);
    this.handleCommentChange = this.handleCommentChange.bind(this);
    this.saveVisitorComment = this.saveVisitorComment.bind(this);
    
    
    
  }
  
  
  componentDidMount() {
    const { isAuthenticated ,updateUserProfileAction} = this.props;
    //isAuthenticated();
    //updateUserProfileAction(this.props.userProfile, this.props.loginData.accessToken);
    updateUserProfileAction(null, this.props.loginData.accessToken);
    //updateAuth();
    // console.log("Farshid the loginData " + this.props.loginData.accessToken)  ;
    
  }
  
  
  handleChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };
  
  handleFirstNameChange(event) {
    //event.preventDefault();
    this.setState(Object.assign(this.state.userComment,{firstname:event.target.value}));
    
    //this.setState({userComment , {{firstname:event.target.value }});
    // this.setState(Object.assign(this.state.firstname, event.target.value));
  }
  
  handleLastNameChange(event) {
    //event.preventDefault();
    //this.setState(Object.assign(this.state.lastname, event.target.value));
    this.setState(Object.assign(this.state.userComment,{lastname:event.target.value}));
    
  }
  
  handleEmailChange(event) {
    //event.preventDefault();
    //this.setState(Object.assign(this.state.email,event.target.value));
    this.setState(Object.assign(this.state.userComment,{email:event.target.value}));
    
  }
  handleCommentChange(event) {
    //event.preventDefault();
    this.setState(Object.assign(this.state.userComment,{comment: event.target.value}));
  }
  
  
  saveVisitorComment(){
    const {saveAComment} = this.props;
    var  returnString="";
    var tempLastName =  this.state.userComment.lastname;
    var tempFirstName = this.state.userComment.firstname;
    var tempEmail = this.state.userComment.email;
    var tempComment = this.state.userComment.comment;
    
    
    if((tempFirstName == null) || (tempFirstName.length == 0)){
      alert("Please provide your first name!");
    }else {
      
      if ((tempLastName == null) || (tempLastName.length == 0)) {
        alert("Please provide your last name!");
      }else {
        
        if ((tempEmail == null) || (tempEmail.length == 0)) {
          alert("Please provide your Email!");
        } else {
          
          if ((tempEmail.indexOf("@") == -1)) {
            alert("Please provide proper Email address!");
          }else{
            if ((tempComment == null) || (tempComment.length == 0)) {
              alert("Please provide your comment!");
            }else{
              //Here send the data to the back end.
              saveAComment(DEFAULT_VESPAAN_SERVER.url, this.state.userComment);
              
            }
          }
        }
      }
    }
    
    return returnString;
  }

//Background color was backgroundColor:'#f4f3ed',
  
  
  render() {
    const { classes } = this.props;
    const MyLink = props => <RouterLink to="#top2" {...props} />
    return (
      
      <div id="top1"  style={{  }}>
        <Grid container spacing={24}>
          
          <Grid   item xs={12} sm={12}  >
            
            
            <div    style = { {  backgroundPosition:'center',  backgroundSize:'cover',  backgroundRepeat:'no-repeat'  }}>
              
              
              <Typography variant="h6" component="h2" style = { { textAlign: 'center', alignSelf: 'center'  , marginTop:10,  color:'#BF360C', fontSize:30}}>
                About {MainConstants.APPLICATION_NAME}&trade;
              </Typography>
              
              <h6 style = { {textAlign: 'center', alignSelf: 'center', color:'Red', fontSize:20}} ></h6>
              
              <div style = { {textAlign: 'center', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300'}}>
                <Grid container spacing={24}>
                  <Grid   item xs={1} sm={1}  >
                  </Grid>
                  <Grid   item xs={10} sm={10}  >
                    <Typography variant="h6" component="h6" style = { {textAlign: 'left', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300'}}>
                      {MainConstants.APPLICATION_NAME}&trade; is a comprehensive, on-demand platform that delivers a safe, secure, scalable, and
                      flexible solution tailored to the needs of vehicle owners and towing companies. Designed with transparency and efficiency in mind,
                      {MainConstants.APPLICATION_NAME}&trade; leverages advanced, multi-channel
                      notification systems to alert vehicle owners in real time when their vehicle is about to be towed.</Typography>
                  <br/>
                    {/*<Typography variant="h6" component="h6" style = { {textAlign: 'left', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300'}}>
                      This proactive alert system empowers owners to retrieve their vehicle on-site—before it is towed—avoiding the
                      added frustration of locating and recovering it from a distant impound lot. If the vehicle owner chooses to recover the
                      vehicle at the scene, all applicable fees due to parking violation- towing service (hook-up, mileage, storage, etc.) —are
                      securely processed through the TowWatch™ app.</Typography>*/}
                  
                        <Typography variant="h6" component="h6" style = { {textAlign: 'left', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300'}}>
                          For vehicle owners, this translates into significant savings in time, cost, and hassle.
                      
                      
                      {/*<Text>For towing operators and enforcement agencies, it ensures
                      compliance, accelerates revenue collection, and improves operational efficiency. TowWatch™ reimagines the towing experience—offering a smart,
                        user-centric approach that benefits all stakeholders involved.</Text>*/}
                      
                      
                      
                      {/*<Text> ******The {MainConstants.APPLICATION_NAME}&trade; platform provides an open, safe, secure, scalable and as-needed service that meets your needs whether
                       you are a vehicle owner, tow company or a traffic and parking enforcement agency. The {MainConstants.APPLICATION_NAME}&trade; service utilizes
                       multiple notification systems to inform a vehicle owner that his or her vehicle is about to be towed and provides the vehicle owner the opportunity to retrieve his or her vehicle on
                       the spot. The vehicle owner will be charged the full parking violation/towing fees (Storage, Mileage, Hooking up, and ...) via the {MainConstants.APPLICATION_NAME}&trade; app.
                       As a vehicle owner, you save time, money and the hassle of getting your vehicle back.</Text>*/}
                    </Typography>
                    <br/>
                    
                    <Typography variant="h6" component="h6" style = { {textAlign: 'left', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', topPadding:'100', width:'300'}}>
                      {MainConstants.APPLICATION_NAME}&trade; empowers tow truck drivers with a streamlined, all-in-one solution to manage
                      their operations more efficiently. Through the platform,
                      drivers can instantly notify vehicle owners that their vehicle is about to be towed and offer them the opportunity to resolve the issue on
                      the spot by paying all applicable parking violation and towing fees. This eliminates the need to hook up and tow the vehicle, saving drivers valuable
                      time, effort, and operational costs.</Typography>
                    <br/>
                    <Typography variant="h6" component="h6" style = { {textAlign: 'left', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', topPadding:'100', width:'300'}}>
                      In addition to on-site payment processing, the {MainConstants.APPLICATION_NAME}&trade; app provides a powerful suite of tools for dispatching calls,
                      managing tow jobs, and securely communicating with vehicle owners—all within a protected and traceable environment.
                      By reducing unnecessary tows and simplifying the workflow, TowWatch™ enhances productivity, increases customer satisfaction,
                      and supports faster revenue collection for drivers and towing companies alike.
                      
                      
                      
                      
                      {/*<Text>The {MainConstants.APPLICATION_NAME}&trade; system provides the tow truck drivers the service to notify the vehicle owners, and to process the parking violation fees on the spot. As a tow truck driver, you save time, money
                      and the hassle of hooking up & towing a vehicle. You can also use {MainConstants.APPLICATION_NAME}&trade; app to dispatch calls, process
                        the tow jobs and communicate with a vehicle owner via the {MainConstants.APPLICATION_NAME}&trade; secure system.</Text>*/}
                    </Typography>
                    
                    <br/>
                  </Grid>
                  <Grid   item xs={1} sm={1}  >
                  </Grid>
                </Grid>
              </div>
              <Typography variant="h6" component="h2" style = { { textAlign: 'center', alignSelf: 'center'  , color:'black', fontSize:24}}>
                Save valuable time, cut costs, and protect the environment!
              </Typography>
            <br/>
              
              
              
              
              <br/>
              
              
              <Typography variant="h6" component="h2" style = { { textAlign: 'center', alignSelf: 'center'  , color:'#BF360C', fontSize:30}}>
                Customer Insight Survey
              </Typography>
              
              <h6 style = { {textAlign: 'center', alignSelf: 'center', color:'Red', fontSize:20}} ></h6>
              
              <div style = { {textAlign: 'center', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300'}}>
                <Grid container spacing={24}>
                  <Grid   item xs={1} sm={1}  >
                  </Grid>
                  <Grid   item xs={10} sm={10}  >
                    <Typography variant="h6" component="h6" style = { {textAlign: 'left', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300'}}>
                      We conducted numerous surveys to better understand the critical needs of vehicle owners across various walks of life.
                      The results revealed a broad
                      demand for the TowWatch™ service/application.
                      Below are some excerpts from our survey findings:
                    </Typography>
                    
                    <br/>
                    
                    <Typography variant="h6" component="h6" style = { {textAlign: 'left', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', topPadding:'100', width:'300'}}>
                    
                    </Typography>
                    
                    <ul>
                      <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d', }}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d', paddingTop:'50'}} > Teenagers - </span>
                        <Grid container spacing={24}  >
                          <Grid   item xs={12} sm={12}  md={8} lg={8}   xl={8} >
                            <div  style={{ marginRight:40 }}>
                                                    <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'black'  }}> As a parent, I want my teenager to have consistent access to their vehicle.
                                                      I don’t want them searching for it in a remote tow yard late at night after a social event or group study session.</span>
                            </div>
                          </Grid>
                          <Grid   item xs={12} sm={12}  md={4} lg={4}   xl={4}  >
                            <div  style={{ marginRight:70, marginLeft:10, marginTop:10,  marginBotton:10}}>
                              <Image
                                //src="/static/images/IMG_3615.JPG"
                                src="/static/images/tow_teenage.png"
                                aspectRatio='(9/6)'
                              />
                            </div>
                          </Grid>
                        
                        </Grid>
                      </li>
                      
                      <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d', paddingTop:10}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} > Elderly parents - </span>
                        <Grid container spacing={24}  >
                          <Grid   item xs={12} sm={12}  md={8} lg={8}   xl={8} >
                            <div  style={{ marginRight:40 }}>
                                                      <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'black'}}> Tracking down a towed vehicle is an exhausting process for my elderly parents.
                                                        I want to ensure they always have easy and uninterrupted access to their vehicle.</span>
                            </div>
                          </Grid>
                          <Grid   item xs={12} sm={12}  md={4} lg={4}   xl={4}  >
                            <div  style={{ marginRight:60, marginLeft:10, marginTop:10,  marginBotton:10}}>
                              <Image
                                //src="/static/images/IMG_3615.JPG"
                                src="/static/images/tow_parents.png"
                                aspectRatio='(9/6)'
                              />
                            </div>
                          </Grid>
                        
                        </Grid></li>
                      
                      <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d', paddingTop:10}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} > Business owner - </span>
                        <Grid container spacing={24}  >
                          <Grid   item xs={12} sm={12}  md={8} lg={8}   xl={8} >
                            <div  style={{ marginRight:40 }}>
                                                    <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'black'}}> As a business owner, constant access to my vehicle is essential. Every moment away from my operations results in significant losses.
                                                      Beyond the cost of recovering my vehicle, it's the lost time—my most valuable resource—that I can't afford.   </span>
                            </div>
                          </Grid>
                          <Grid   item xs={12} sm={12}  md={4} lg={4}   xl={4}  >
                            <div  style={{ marginRight:60, marginLeft:10, marginTop:10,  marginBotton:10}}>
                              <Image
                                //src="/static/images/IMG_3615.JPG"
                                src="/static/images/tow_business.png"
                                aspectRatio='(9/6)'
                              />
                            </div>
                          </Grid>
                        
                        </Grid>
                      </li>
                      
                      <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d' , paddingTop:10}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} > Limited mobility- </span>
                        
                        <Grid container spacing={24}  >
                          <Grid   item xs={12} sm={12}  md={8} lg={8}   xl={8} >
                            <div  style={{ marginRight:40 }}>
                                                      <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'black'}}> With limited mobility, having easy access to my
                                                        vehicle is essential. I don’t want to rely on others to retrieve it from a tow yard,
                                                        as that takes up both my time and the time of those assisting me. </span>
                            </div>
                          </Grid>
                          <Grid   item xs={12} sm={12}  md={4} lg={4}   xl={4}  >
                            <div  style={{ marginRight:70, marginLeft:10, marginTop:10,  marginBotton:10}}>
                              <Image
                                //src="/static/images/IMG_3615.JPG"
                                src="/static/images/tow-immobile_person.jpg"
                                aspectRatio='(9/6)'
                              />
                            </div>
                          </Grid>
                        
                        </Grid></li>
                      
                      <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d', paddingTop:10}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} > Busy parent - </span>
                        <Grid container spacing={24}  >
                          <Grid   item xs={12} sm={12}  md={8} lg={8}   xl={8} >
                            <div  style={{ marginRight:40 }}>
                                                    <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'black'}}> As a mother of two young children, my vehicle is essential
                                                      for managing our daily routine—from school drop-offs and
                                                      extracurricular activities to sports events, birthday parties, and social gatherings.. </span>
                            </div>
                          </Grid>
                          <Grid   item xs={12} sm={12}  md={4} lg={4}   xl={4}  >
                            <div  style={{ marginRight:70, marginLeft:10, marginTop:10,  marginBotton:10}}>
                              <Image
                                //src="/static/images/IMG_3615.JPG"
                                src="/static/images/tow_mother.png"
                                aspectRatio='(9/6)'
                              />
                            </div>
                          </Grid>
                        
                        </Grid>
                      </li>
                      
                      <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d', paddingTop:10}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} > Sport coach - </span>
                        <Grid container spacing={24}  >
                          <Grid   item xs={12} sm={12}  md={8} lg={8}   xl={8} >
                            <div  style={{ marginRight:40 }}>
                                                    <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'black'}}> As a local sports coach, I’m responsible for
                                                      transporting our team to practices, games, and events. My vehicle plays a vital role in keeping everything running smoothly.
                                                      Losing access to it would not only disrupt the team’s
                                                      schedule but also impact the players and their families who depend on me for reliable transportation. </span>
                            </div>
                          </Grid>
                          <Grid   item xs={12} sm={12}  md={4} lg={4}   xl={4}  >
                            <div  style={{ marginRight:70, marginLeft:10, marginTop:10,  marginBotton:10}}>
                              <Image
                                //src="/static/images/IMG_3615.JPG"
                                src="/static/images/tow_coach.png"
                                aspectRatio='(9/6)'
                              />
                            </div>
                          </Grid>
                        
                        </Grid>
                      
                      </li>
                      
                      <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d', paddingTop:10}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} > Medical staff - </span>
                        <Grid container spacing={24}  >
                          <Grid   item xs={12} sm={12}  md={8} lg={8}   xl={8} >
                            <div  style={{ marginRight:40 }}>
                                                    <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'black'}}> As a medical professional, I must be able to reach
                                                      healthcare facilities quickly, especially in emergency situations. Timeliness can be critical to patient outcomes, and having immediate
                                                      access to my vehicle is absolutely essential. Any delay caused by not having my vehicle readily available could hinder my ability to respond when I’m needed most.
                                                      Reliable transportation isn’t just a convenience—it’s a responsibility tied directly to the care I provide. </span>
                            </div>
                          </Grid>
                          <Grid   item xs={12} sm={12}  md={4} lg={4}   xl={4}  >
                            <div  style={{ marginRight:70, marginLeft:10, marginTop:10,  marginBotton:10}}>
                              <Image
                                //src="/static/images/IMG_3615.JPG"
                                src="/static/images/tow_medical.png"
                                aspectRatio='(9/6)'
                              />
                            </div>
                          </Grid>
                        
                        </Grid>
                      
                      </li>
                      
                      <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d', paddingTop:10}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} > Luxury vehicle - </span>
                        <Grid container spacing={24}  >
                          <Grid   item xs={12} sm={12}  md={8} lg={8}   xl={8} >
                            <div  style={{ marginRight:40 }}>
                              <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'black'}}>My luxury vehicle is a significant investment and
                                holds great personal value to me. I take pride in maintaining it and ensuring it’s always in top condition. The idea of it
                                being towed is not only stressful but also raises concerns about potential damage,
                                inconvenience, and costly retrieval. I want full control over its location and security at all times. </span>
                            
                            </div>
                          </Grid>
                          <Grid   item xs={12} sm={12}  md={4} lg={4}   xl={4}  >
                            <div  style={{ marginRight:70, marginLeft:10, marginTop:10,  marginBotton:10}}>
                              <Image
                                //src="/static/images/IMG_3615.JPG"
                                src="/static/images/tow_luxary.png"
                                aspectRatio='(9/6)'
                              />
                            </div>
                          </Grid>
                        
                        </Grid>
                      </li>
                    
                    
                    </ul>
                  
                  
                  
                  
                  </Grid>
                  <Grid   item xs={1} sm={1}  >
                  </Grid>
                </Grid>
              </div>
              
              <Typography variant="h6" component="h2" style = { { textAlign: 'center', alignSelf: 'center'  , color:'#BF360C', fontSize:30}}>
                Tow Statistics
              </Typography>
              
              <h6 style = { {textAlign: 'center', alignSelf: 'center', color:'Red', fontSize:12}} ></h6>
              
              <div style = { {textAlign: 'center', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300'}}>
                <Grid container spacing={24}>
                  <Grid   item xs={1} sm={1}  >
                  </Grid>
                  <Grid   item xs={10} sm={10}  >
                    <Typography variant="h6" component="h6" style = { {textAlign: 'left', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300'}}>
                      Based on available data, approximately 20 million vehicles (20/298 = 6.7% of registered vehicles)  in the United States are towed each year. This estimate is derived from the following figures:
                    
                    </Typography>
                    <ul>
                      <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} > Daily Tows - </span>
                        <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}> An estimated 55,000 vehicles are towed daily in the U.S. <a target="_blank"   rel="noopener noreferrer" href="https://www.lookupaplate.com/blog/towing-industry-statistics/?utm_source=chatgpt.com"   >
                                                 (Source)
                                            </a>
                                                </span></li>
                      
                      <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} > Annual Tows - </span>
                        <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}> Multiplying the daily tows by 365 days yields approximately 20 million vehicles towed annually.</span> </li>
                      
                      <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} > Registered Vehicles - </span>
                        <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}> As of 2025, there are about 298.7 million registered vehicles in the U.S. <a target="_blank"   rel="noopener noreferrer" href="https://hedgescompany.com/automotive-market-research-statistics/auto-mailing-lists-and-marketing/?utm_source=chatgpt.com"   >
                                                 (Source)
                                            </a></span> </li>
                      
                      <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} > Parking Violations - </span>
                        <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}> Approximately 25–50% of tows are due to parking infractions, 5–10 million vehicles annually.</span> </li>
                      
                      <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} > Accidents/Disabled Vehicles - </span>
                        <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}> Around 30–45% result from accidents or mechanical failures, 6–9 million vehicles</span> </li>
                      
                      <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} > Private Property Impounds - </span>
                        <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}> About 5–15% involve unauthorized parking on private property, 1–3 million vehicles.</span> </li>
                    
                    
                    </ul>
                    
                    <Typography variant="h6" component="h6" style = { {textAlign: 'left', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300'}}>
                      So the total tows for Parking Violations and Private Property Impounds is about 30-65% of tows, which is 6-13 million vehicles each year.
                    
                    </Typography>
                    
                    <br/>
                    
                    <Typography variant="h6" component="h6" style = { {textAlign: 'left', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', topPadding:'100', width:'300'}}>
                    
                    </Typography>
                  
                  
                  </Grid>
                  <Grid   item xs={1} sm={1}  >
                  </Grid>
                </Grid>
              </div>
              
              <br/>
              <br/>
              <Typography variant="h6" component="h2" style = { { textAlign: 'center', alignSelf: 'center'  , color:'#BF360C', fontSize:30}}>
                Private & Secure Communication
              </Typography>
              
              <h6 style = { {textAlign: 'center', alignSelf: 'center', color:'Red', fontSize:12}} ></h6>
              
              <div style = { {textAlign: 'center', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300'}}>
                <Grid container spacing={24}>
                  <Grid   item xs={1} sm={1}  >
                  </Grid>
                  <Grid   item xs={10} sm={10}  >
                    <Typography variant="h6" component="h6" style = { {textAlign: 'left', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300'}}>
                      {MainConstants.APPLICATION_NAME}&trade; ensures the privacy and security of vehicle owners and operators by safeguarding their identities at all times. Personal
                      contact information is never disclosed to third parties. All communications related to towing events are securely managed and recorded
                      within the {MainConstants.APPLICATION_NAME}&trade; platform. Users are only contacted through the system and strictly in relation to
                      tow-related activities, ensuring a controlled, confidential, and professional communication experience.
                    </Typography>
                    
                    <br/>
                    
                    <Typography variant="h6" component="h6" style = { {textAlign: 'left', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', topPadding:'100', width:'300'}}>
                    
                    </Typography>
                  
                  
                  </Grid>
                  <Grid   item xs={1} sm={1}  >
                  </Grid>
                </Grid>
              </div>
              
              
              
              <br/>
              
              <a href="/privacy"   rel="noreferrer" style={{paddingLeft:10, paddingBottom:20, display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                <Typography component="h2" variant="body1" style = { { color:'blue'}} >
                  Privacy Policy
                </Typography>
              </a>
              
              
              {/*}
                                                            <Typography variant="h6" component="h2" style = { { textAlign: 'center', alignSelf: 'center'  , color:'#BF360C', fontSize:30}}>
                                                          Safe and Secure Communication
                                                          </Typography>
                                                      
                                                          <h6 style = { {textAlign: 'center', alignSelf: 'center', color:'Red', fontSize:20}} ></h6>
                                                      
                                                          <div style = { {textAlign: 'center', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300'}}>
                                                          <Grid container spacing={24}>
                                                            <Grid   item xs={1} sm={1}  >
                                                            </Grid>
                                                            <Grid   item xs={10} sm={10}  >
                                                            <Typography variant="h6" component="h6" style = { {textAlign: 'left', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300'}}>
                                                            The vehicle owners’ and operators’ identities are protected by the safe and secure PlateWiz&trade; system. Their contact information is never revealed.
                                                              All the communications are handled within PlateWiz&trade; system and are recorded.
                                                              A user is only contacted by and through the system on the tow related events.
                                                            </Typography>
                                                      
                                                          <br/>
                                                      
                                                          <Typography variant="h6" component="h6" style = { {textAlign: 'left', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', topPadding:'100', width:'300'}}>
                                                    
                                                        </Typography>
      
      
                                                          </Grid>
                                                          <Grid   item xs={1} sm={1}  >
                                                          </Grid>
                                                          </Grid>
                                                            </div> */}
            
            
            
            
            </div>
          
          
          
          </Grid>
        
        
        
        </Grid>
      </div>
    
    
    
    );
  }
}

AboutPlateWiz.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  return {
    isAuthenticatedBool: state.login.isAuthenticatedBool,
    userProfile: state.login.userProfile,
    loginData:state.login.loginData,
    
    //auth:state.login.loginData,
    //CompanyDeleteResponse:state.account.deleteCompanyResp,
    //CompanySaveResponse:state.account.saveCompanyResp,
    //locationsArray:state.location.locationsArray,
    //vcArray:state.videocontroller.vcArray,
    //camerasArray:state.camera.camerasArray,
    //errorCMsg:state.account.errorCMsg,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    //login:login,
    //handleAuthentication:handleAuthentication,
    //isAuthenticated:isAuthenticated,
    updateUserProfileAction:updateUserProfileAction,
    saveAComment:saveAComment,
    //updateAuth:updateAuth,
    
  }, dispatch);
};

//export default BiomassView;
//export default withStyles(styles)(AboutPlateWiz);




//export default withStyles(styles)(AppView);
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AboutPlateWiz));
